const routes = {
  dashboardPage: '/',
  merchantDashboardPage: '/merchant-dashboard',
  transactionsPage: '/transactions',
  merchantTransactionsPage: '/merchant-transactions',
  loginPage: '/login',
  transactionDetailPage: '/transactions/:id',
  merchantTransactionsTransactionDetailPage: '/merchant-transactions/:id',
  transactionValidationPage: '/transactions/:id/validation',
  transactionIssueRefund: '/transactions/:id/issue-refund',
  transactionReviewAdditionalProducts: '/transactions/:id/review-additional-products',
  transactionRMA: '/transactions/rma',
  inventoryPage: {
    index: '/inventory',
  },
  configurationPage: {
    index: '/config',
    store: '/config/store',
    branding: '/config/branding',
    refunds: '/config/refunds',
    refundsDetail: '/config/refunds/:id',
    returnPolicy: {
      config: '/config/return-policy',
      exceptions: '/config/return-policy/allow-list',
      exceptionDetail: '/config/return-policy/allow-list/:id',
      policyRules: '/config/return-policy/policy-rules',
      policyRuleDetail: '/config/return-policy/policy-rules/:id',
    },
    logistics: {
      deliveryMethods: '/config/logistics/delivery-methods',
      deliveryMethodDetailConfiguration: '/config/logistics/delivery-methods/:id',
      availabilityCriterionDetail: '/config/logistics/delivery-methods/availability-criterion/:id',
      returnInstructions: '/config/logistics/return-instructions',
      returnInstructionDetailConfiguration: '/config/logistics/return-instructions/:id',
      locations: '/config/logistics/locations',
      locationDetailConfiguration: '/config/logistics/locations/:id',
      shippingMethods: '/config/logistics/shipping-methods',
      shippingMethodDetailConfiguration: '/config/logistics/shipping-methods/:id',
      shippingAvailabilityCriterionDetail: '/config/logistics/shipping-methods/availability-criterion/:id',
      general: '/config/logistics/general',
      packaging: '/config/logistics/packaging',
      packagingDetailConfiguration: '/config/logistics/packaging/:id',
    },
    returnProtection: {
      general: '/config/return-protection/general',
      appearance: '/config/return-protection/appearance',
    },
    copies: '/config/copies',
    returnReasons: '/config/return-reasons',
    returnReasonsDetail: '/config/return-reasons/:id',
    returnReasonsSettings: '/config/return-reasons/settings',
    billing: '/config/billing',
    extras: {
      reveniWidget: '/config/extras/reveni-widget',
      shippingWidget: '/config/extras/shipping-widget',
      sizingWidget: '/config/extras/sizing-widget',
      bracketingWidget: '/config/extras/bracketing-widget',
      topBannerWidget: '/config/extras/top-banner-widget',
      tryOnWidget: '/config/extras/try-on-widget',
    },
    communications: '/config/communications',
    emailTemplates: '/config/email-templates',
    emailTemplateDetail: '/config/email-templates/:id',
    themes: '/config/themes',
    users: '/config/users',
    userDetail: '/config/users/:id',
    group: '/config/users/group',
    groupDetail: '/config/users/group/:id',
    integrations: '/config/integrations',
    integrationsDetail: '/config/integrations/:id',
    inventory: '/config/inventory',
    orderTrackingPage: {
      config: '/config/order-tracking-page',
      visibilityCriterionDetail: '/config/order-tracking-page/visibility-criteria/:id',
    },
    returnsPortal: {
      config: '/config/returns-portal',
      copies: '/config/returns-portal/copies',
    },
  },
  merchantConfigurationPage: {
    index: '/merchant-config',
    refunds: '/merchant-config/refunds',
    refundsDetail: '/merchant-config/refunds/:id',
    returnPolicy: '/merchant-config/return-policy',
    branding: '/merchant-config/branding',
    communications: '/merchant-config/communications',
    emailTemplates: '/merchant-config/email-templates',
    emailTemplateDetail: '/merchant-config/email-templates/:id',
    themes: '/merchant-config/themes',
  },
  accountPage: {
    index: '/account',
    profile: '/account/profile',
    security: '/account/security',
    preferences: '/account/preferences',
  },
  analyticsPage: '/analytics',
  performanceInsights: '/performance-insights',
  signupPage: '/signup',
  billingPage: '/billing',
  billingDetailPage: '/billing/:id',
  parcelsPage: {
    index: '/parcels',
    outbound: '/parcels/outbound',
    inbound: '/parcels/inbound',
  },
  performanceInsightsPage: {
    global: '/performance-insights/global',
    markets: '/performance-insights/markets',
    products: '/performance-insights/products',
    logistics: '/performance-insights/logistics',
  },
  parcelDetailPage: '/parcels/:id',
  parcelPreparePage: '/parcels/:id/prepare',
  parcelSplitPage: '/parcels/:id/split',
  shipmentsMetricsPage: '/global-shipments',
  productMetricsDetailPage: '/products/:position/metrics',
  merchantDashboardProductMetricsDetailPage: '/merchant-dashboard/products/:position/metrics',
  productVariantMetricsDetailPage: '/products/:productPosition/variants/:variantPosition/metrics',
  merchantDashboardProductVariantMetricsDetailPage:
    '/merchant-dashboard/products/:productPosition/variants/:variantPosition/metrics',
  variantMetricsDetailPage: '/variants/:variantPosition/metrics',
  merchantDashboardVariantMetricsDetailPage: '/merchant-dashboard/variants/:variantPosition/metrics',
  reasonMetricsDetailPage: '/reason/:reasonKey/metrics',
  merchantDashboardReasonMetricsDetailPage: '/merchant-dashboard/reason/:reasonKey/metrics',
  subReasonMetricsDetailPage: '/reason/:reasonKey/sub-reasons/:subReasonId/metrics',
  merchantDashboardSubReasonMetricsDetailPage: '/merchant-dashboard/reason/:reasonKey/sub-reasons/:subReasonId/metrics',
  productByReasonMetricsDetailPage: '/reason/:reasonKey/products/:productPosition/metrics',
  merchantDashboardProductByReasonMetricsDetailPage:
    '/merchant-dashboard/reason/:reasonKey/products/:productPosition/metrics',
  categoryMetricsDetailPage: '/categories/:categoryPosition/metrics',
  merchantDashboardCategoryMetricsDetailPage: '/merchant-dashboard/categories/:categoryPosition/metrics',
  productByCategoryMetricsDetailPage: '/categories/:categoryPosition/products/:productPosition/metrics',
  merchantDashboardProductByCategoryMetricsDetailPage:
    '/merchant-dashboard/categories/:categoryPosition/products/:productPosition/metrics',
  variantByCategoryMetricsDetailPage:
    '/categories/:categoryPosition/products/:productPosition/variants/:variantPosition/metrics',
  merchantDashboardVariantByCategoryMetricsDetailPage:
    '/merchant-dashboard/categories/:categoryPosition/products/:productPosition/variants/:variantPosition/metrics',
  typeMetricsDetailPage: '/types/:typePosition/metrics',
  merchantDashboardTypeMetricsDetailPage: '/merchant-dashboard/types/:typePosition/metrics',
  productByTypeMetricsDetailPage: '/types/:typePosition/products/:productPosition/metrics',
  merchantDashboardProductByTypeMetricsDetailPage:
    '/merchant-dashboard/types/:typePosition/products/:productPosition/metrics',
  variantByTypeMetricsDetailPage: '/types/:typePosition/products/:productPosition/variants/:variantPosition/metrics',
  merchantDashboardVariantByTypeMetricsDetailPage:
    '/merchant-dashboard/types/:typePosition/products/:productPosition/variants/:variantPosition/metrics',
  collectionMetricsDetailPage: '/collections/:collectionPosition/metrics',
  merchantDashboardCollectionMetricsDetailPage: '/merchant-dashboard/collections/:collectionPosition/metrics',
  productByCollectionMetricsDetailPage: '/collections/:collectionPosition/products/:productPosition/metrics',
  merchantDashboardProductByCollectionMetricsDetailPage:
    '/merchant-dashboard/collections/:collectionPosition/products/:productPosition/metrics',
  variantByCollectionMetricsDetailPage:
    '/collections/:collectionPosition/products/:productPosition/variants/:variantPosition/metrics',
  merchantDashboardVariantByCollectionMetricsDetailPage:
    '/merchant-dashboard/collections/:collectionPosition/products/:productPosition/variants/:variantPosition/metrics',
}

export default routes
